module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-5905HD_white-c09aeede529690ef7eb52fac300b36ef.png";